import React from 'react';
import './App.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearStaffPortalSession } from './staffPortalSession';

function StaffHeader() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = (path) => {
    setOpen(false);
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  return (
    <header className="sh-root">
      <div className="sh-left">
        <span className="sh-app-name">Staff workspace</span>
        <span className="sh-app-sub">Navigation</span>
      </div>

      <div className="sh-right">
        <button
          type="button"
          className={`sh-toggle ${open ? 'sh-toggle--open' : ''}`}
          aria-label="Open staff menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
        </button>

        {open && (
          <div className="sh-menu" role="menu">
            <button
              type="button"
              className="sh-menu-item"
              onClick={() => goTo('/staff-dashboard')}
            >
              Dashboard
            </button>
            <button
              type="button"
              className="sh-menu-item"
              onClick={() => goTo('/profile')}
            >
              Profile
            </button>
            <button
              type="button"
              className="sh-menu-item sh-menu-item--logout"
              onClick={() => {
                setOpen(false);
                clearStaffPortalSession();
                navigate('/admin', { replace: true });
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default StaffHeader;

